import {
  Button,
  ButtonGroup,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from "@mui/material";
import React from "react";
import CardHeaderTitle from "../../components/card-header-title/index.jsx";
import { toggleButtonStyle } from "../../consts.js";
// New TopQuestionsCard Component

const TopQuestionsCard = ({ data, pickedAgent, setPickedAgent, colours, themeMode }) => {
  const agentSpeaker = data?.agentSpeaker || "Speaker 2";
  const clientSpeaker = data?.clientSpeaker || "Speaker 1";

  return (
    <Paper
      sx={{ display: "flex", flexDirection: "column", width: '100%', borderRadius: 2.5, padding: 3, boxSizing: "border-box" }}
    >
      <Stack
        direction="row"
        flexWrap="wrap"
        gap={.5}
        justifyContent="space-between"
        alignItems="center"
      >
        <CardHeaderTitle
          title="Top Questions"
          tooltip="The top questions asked by Agents and Clients."
        />

        <ButtonGroup
          variant="contained"
          aria-label="outlined primary button group"
          className="buttons-border-extend"
        >
          <Button
            onClick={() => setPickedAgent(true)}
            style={toggleButtonStyle(pickedAgent, colours, themeMode)}
          >
            Agent
          </Button>
          <Button
            onClick={() => setPickedAgent(false)}
            style={toggleButtonStyle(!pickedAgent, colours, themeMode)}
          >
            Client
          </Button>
        </ButtonGroup>
      </Stack>
      <div style={{ marginTop: 16 }}>
        <TableContainer>
          <Table size="small" aria-label="Top Questions Table">
            <TableBody>
              {!data.questionhits ? (
                <TableRow />
              ) : (
                data.questionhits
                  .filter((z) =>
                    pickedAgent
                      ? z.speaker === clientSpeaker
                      : z.speaker === agentSpeaker
                  )
                  .sort((a, b) => b.n - a.n)
                  .slice(0, 10) // top questions 10 length
                  .map((z, zi) => (
                    <TableRow hover key={zi}>
                      <TableCell
                        style={{
                          paddingTop: 3,
                          paddingBottom: 3,
                        }}
                      >
                        {zi + 1 + ". " + z.text}
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </Paper>
  );
};

export default TopQuestionsCard;
